import styled, {keyframes} from 'styled-components'
import {getCurrentColors} from '../../../../utils/colors'
import {
    useCallback,
    useContext,
    useEffect,
    useLayoutEffect,
    useState,
} from 'react'
import {HistoryContext} from '../../../../contexts/history'
import Message from './message/message'
import Input from './input/input'
import {breakpoints} from '../../../../utils/configs'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined'
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined'
import Background from '../../../../assets/background.svg'
import {AuthContext} from '../../../../contexts/auth'
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined'
import ChatIcon from '../../../../assets/ChatIcon.svg'
import Alert from '@mui/material/Alert'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import {useRef} from 'react'
import {useLoading} from '../../../../globalComponents/useLoading'
import {v4 as uuidv4} from 'uuid'
import GuruICon from '../../../../assets/GuruIcon.svg'
import LanguageIcon from '@mui/icons-material/Language'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import {Virtuoso, type VirtuosoHandle} from 'react-virtuoso'

const COLORS = getCurrentColors()

const DAYS_PT = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']
const MONTHS_PT = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']

function getDateLabel(date: Date | string): string {
    const d = new Date(date)
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const messageDay = new Date(d.getFullYear(), d.getMonth(), d.getDate())
    const diffDays = Math.round((today.getTime() - messageDay.getTime()) / (1000 * 60 * 60 * 24))

    if (diffDays === 0) return 'Hoje'
    if (diffDays === 1) return 'Ontem'
    if (diffDays < 7) return DAYS_PT[d.getDay()]
    if (d.getFullYear() === now.getFullYear()) return `${d.getDate()} de ${MONTHS_PT[d.getMonth()]}`
    return String(d.getFullYear())
}

interface MotorButtonProps {
    isOpen: boolean
}

interface MenuItemProps {
    isSelected: boolean
}

interface DropdownMenuProps {
    isOpen: boolean
}
const pulse = keyframes`
    0% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(2.5);
        opacity: 0;
    }
    100% {
        transform: scale(1);
        opacity: 0;
    }
`

const PulsingCircle = styled.div`
    width: 8px;
    height: 8px;
    background-color: #25d366;
    border-radius: 50%;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: #25d366;
        animation: ${pulse} 1.5s infinite;
    }
`

const Section = styled.section`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex: 1;
    min-height: 0;
    position: relative;
    background-color: #f6f8fa;
    background-image: url(${Background});
    background-repeat: no-repeat;
    background-position: right 370px;
    background-size: 800px;
    padding: 0;
    overflow: hidden;

    @media screen and (max-width: 640px) {
        padding: 0 15px;
    }

    @media screen and (${breakpoints.sm}) {
        width: 100vw;
    }
`

const TopBar = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 20px 0 12px;
    flex-shrink: 0;
`

const TopBarContent = styled.div`
    max-width: 100%;
    display: flex;
    justify-content: flex-end;
    position: relative;

    margin-left: 50%;
`

const ScrollContent = styled.div`
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const BottomBar = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 5px 0 5px;
    flex-shrink: 0;
`

const BottomBarContent = styled.div`
    width: 795px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

const Footer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 12px;
    color: #6b7280;
`

const Body = styled.div<{noMessage?: boolean}>`
    flex: 1;
    display: flex;
    flex-direction: column;
    ${({noMessage}) => (noMessage ? 'justify-content: center;' : '')}
    width: 795px;
    max-width: 100%;

    @media (max-height: 760px) {
        margin-top: -12%;
        justify-content: flex-start;
    }
`

const Body2 = styled.div<{noMessage?: boolean}>`
    flex: 1;
    display: flex;
    flex-direction: column;
    ${({noMessage}) => (noMessage ? 'justify-content: center;' : '')}
    width: 100%;
    max-width: 800px;
`

const BodyMessage = styled.div<{isUser?: boolean}>`
    display: flex;
    justify-content: ${({isUser}) => (isUser ? 'flex-end' : 'flex-start')};
    width: 100%;
    padding: 5px 0;
`

const SelectedSchiefMessage = styled.span`
    font-size: 12px;
    font-weight: 400;
    position: absolute;
    text-align: center;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
`
const NoMessageText = styled.span`
    align-self: center;
    font-weight: 400;
`

const ModalContent = styled.div`
    background-color: white;
    border-radius: 8px;
    width: 100%;
    max-width: 80%;
    max-height: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 24px;
    outline: none;
    display: flex;
    flex-direction: column;

    @media (min-width: 768px) {
        /* Para tablets e maiores */
        width: 60%;
    }

    @media (min-width: 1024px) {
        /* Para telas de desktop */
        width: 40%;
    }
`

const NewMessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: auto;
    position: relative;
    margin-top: 20%;

    @media screen and (${breakpoints.md}) {
        margin-top: 15%;
    }

    @media screen and (${breakpoints.sm}) {
        margin-top: 10%;
    }
`

const TitleNewMessage = styled.h1`
    font-size: 62px;
    font-weight: 600;
    align-self: flex-start;
    background: linear-gradient(
        271.31deg,
        ${COLORS.secundariaEscura} 40.96%,
        ${COLORS.primariaEscura} 120.72%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    @media screen and (${breakpoints.md}) {
        font-size: 48px;
    }

    @media screen and (${breakpoints.sm}) {
        font-size: 36px;
    }

    @media (max-height: 760px) {
        font-size: 36px;
    }
`

const SubtitleNewMessage = styled.h2`
    font-size: 16px;
    font-weight: 400;
    color: #838383;
    max-width: 500px;
    align-self: flex-start;
    margin-top: 20px;

    @media screen and (${breakpoints.md}) {
        font-size: 14px;
        max-width: 400px;
    }

    @media screen and (${breakpoints.sm}) {
        font-size: 12px;
        max-width: 300px;
    }
`

const SugestionsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    width: 100%;
    margin-top: 24px;
    gap: 16px;
`

const SugestionContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 250px;
    height: 70px;
    border-radius: 8px;
    border: 0.8px solid #e0e0e0;
    background-color: #ffffff;
    padding: 10px;
    cursor: pointer;
    wrap: wrap;
`

const StyledIconButton = styled(IconButton)``

const HeadModal = styled.div`
    display: flex;
    padding: 20px;
    justify-content: space-between;
`

const BodyModal = styled.div`
    aling-content: center;
    display: flex;
    padding: 20px;
    overflow-y: auto;
`

const PaginationControls = styled.div`
    display: flex;
    justify-content: center;
    padding: 0 20px 20px;
`

const MotorButton = styled.button<MotorButtonProps>`
    display: flex;
    align-items: center;
    gap: 4px;
    background: #ffffff;
    padding: 6px 10px;
    border-radius: 14px;
    font-size: 13px;
    color: #4b5563;
    border: none;
    cursor: pointer;
    transition: all 0.2s;
    min-width: 180px;
    height: 32px;
    white-space: nowrap;
    justify-content: space-between;
    flex-shrink: 0;

    &:hover {
        background: #e5e7eb;
    }

    .button-content {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .arrow-icon {
        font-size: 16px;
        transition: transform 0.2s;
        transform: ${({isOpen}) => (isOpen ? 'rotate(180deg)' : 'rotate(0)')};
    }
`
const MenuItem = styled.button<MenuItemProps>`
    width: 100%;
    padding: 8px 16px;
    text-align: left;
    background: ${({isSelected}) => (isSelected ? '#f3f4f6' : 'transparent')};
    border: none;
    cursor: pointer;
    font-size: 14px;
    color: #4b5563;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
        background: #f3f4f6;
    }

    &:first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }

    &:last-child {
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
    }
`
const DropdownMenu = styled.div<DropdownMenuProps>`
    position: absolute;
    top: 55px;
    right: 60;
    background: white;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
    display: ${({isOpen}) => (isOpen ? 'block' : 'none')};
    z-index: 10;
    min-width: 180px;
`
const ButtonTitle = styled.div`
    @media (max-width: 455px) {
        text-align: left;
        font-size: 10px;
        white-space: normal;
        overflow-wrap: break-word;
        word-break: break-word;
        line-height: 1.2;
        max-width: 120px;
    }
`

const Image = styled.img`
    align-self: center;
    margin-right: 10px;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
`

const DateSeparatorWrapper = styled.div<{isSticky?: boolean}>`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
    width: 100%;
    position: ${({isSticky}) => (isSticky ? 'sticky' : 'static')};
    top: ${({isSticky}) => (isSticky ? '8px' : 'auto')};
    z-index: ${({isSticky}) => (isSticky ? 2 : 'auto')};
`

const DateBadge = styled.span`
    background-color: rgba(255, 255, 255, 0.92);
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 4px 14px;
    font-size: 12px;
    color: #6b7280;
    font-weight: 500;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07);
    user-select: none;
`

const SugestionTitle = styled.div`
    font-size: 14px;
`

const SugestionSubtitle = styled.div`
    font-size: 12px;
    color: #666;
    padding: 4px;
`

export default function Chat({
    perguntaInicial = '',
}: {
    perguntaInicial?: string
}) {
    const {
        messagesArray,
        selected,
        assistant,
        setUnarchieveModal,
        unarchieveModal,
        archivedThread,
        archivedThreadPage,
        goToArchivedThreadsPage,
        unarchiveThread,
        limits,
        openModelAlertLimit,
        setOpenModelAlertLimit,
        loadingMessageBot,
        setUuid,
        uuid,
        setAssistant,
        assistants,
    } = useContext(HistoryContext)
    const handleClose = () => {
        setUnarchieveModal(false)
        setFinishedTest(false)
    }
    const {userInfo} = useContext(AuthContext)
    const [suggestion, setSuggestion] = useState('')
    const scrollContentRef = useRef<HTMLDivElement>(null)
    const listRef = useRef<VirtuosoHandle | null>(null)
    const [listHeight, setListHeight] = useState(0)
    const [finishedTest, setFinishedTest] = useState(false)
    const {LoadingMessage, setIsLoading, isLoading} = useLoading()
    const [idUnico, setIdUnico] = useState(uuidv4())
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)
    const [visibleDateLabel, setVisibleDateLabel] = useState('')
    const lastMessage = messagesArray[messagesArray.length - 1]
    const lastMessageText = lastMessage?.response || lastMessage?.content || ''

    const CHAT_SUGGESTIONS = [
        {
            id: 'planejamento',
            title: 'Planejamento de Contratação',
            subtitle:
                'Sou da equipe de planejamento de contratações públicas...',
            prompt: 'Sou da equipe de planejamento de contratações públicas e preciso de apoio técnico-jurídico para um caso concreto. Por favor, elabore uma minuta de texto para o tópico xxxxxxxxxxxxxx do documento xxxxxxxxxxxxxxx. Considere que xxxxxxxxxxxxxx.',
        },
        {
            id: 'impugnacao',
            title: 'Impugnação ao Edital',
            subtitle: 'Sou pregoeiro e recebi uma impugnação ao edital...',
            prompt: 'Sou pregoeiro em uma licitação que se subordina à Lei 14.133/2021 e recebi uma impugnação ao edital. Minute uma resposta à impugnação, com introdução, desenvolvimento e conclusão, apresentando o argumento da impugnação e uma análise jurídica sobre este argumento. Ao final, conclua pela procedência ou pela improcedência da impugnação. O conteúdo da impugnação é este: xxxxxxxxxxxx. Considere, para a sua análise, que xxxxxxxxxxxxxxx.',
        },
        {
            id: 'gestao_contratos',
            title: 'Gestão de Contratos',
            subtitle:
                'Sou fiscal/gestor de contrato e preciso decidir sobre um pleito...',
            prompt: 'Sou fiscal/gestor de um contrato administrativo e preciso decidir sobre um pleito apresentado pelo particular contratado. Minute uma resposta ao pleito, com introdução, desenvolvimento e conclusão, com uma análise jurídica sobre o pleito. Ao final, conclua pela procedência ou pela improcedência. O contratado solicita que xxxxxxx, sob o argumento de que xxxxxxxx. Considere, para a sua análise, que xxxxxxxxxxx.',
        },
    ]

    const CHAT_SUGGESTIONS_FINEP = [
        {
            id: 'planejamento',
            title: 'Planejamento de Contratação',
            subtitle:
                'Sou da equipe de planejamento de contratações públicas...',
            prompt: 'Sou da equipe de planejamento de contratações públicas e preciso de apoio técnico-jurídico para um caso concreto. Por favor, elabore uma minuta de texto para o tópico xxxxxxxxxxxxxx do documento xxxxxxxxxxxxxxx. Considere que xxxxxxxxxxxxxx.',
        },
        {
            id: 'impugnacao',
            title: 'Impugnação ao Edital',
            subtitle: 'Sou pregoeiro e recebi uma impugnação ao edital...',
            prompt: 'Sou pregoeiro em uma licitação que se subordina à Lei 13.303/2016 e recebi uma impugnação ao edital. Minute uma resposta à impugnação, com introdução, desenvolvimento e conclusão, apresentando o argumento da impugnação e uma análise jurídica sobre este argumento. Ao final, conclua pela procedência ou pela improcedência da impugnação. O conteúdo da impugnação é este: xxxxxxxxxxxx. Considere, para a sua análise, que xxxxxxxxxxxxxxx.',
        },
        {
            id: 'gestao_contratos',
            title: 'Gestão de Contratos',
            subtitle:
                'Sou fiscal/gestor de contrato e preciso decidir sobre um pleito...',
            prompt: 'Sou fiscal/gestor de um contrato administrativo e preciso decidir sobre um pleito apresentado pelo particular contratado. Minute uma resposta ao pleito, com introdução, desenvolvimento e conclusão, com uma análise jurídica sobre o pleito. Ao final, conclua pela procedência ou pela improcedência. O contratado solicita que xxxxxxx, sob o argumento de que xxxxxxxx. Considere, para a sua análise, que xxxxxxxxxxx.',
        },
    ]

    const CHAT_SUGGESTIONS_PRODESP = [
        {
            id: 'planejamento',
            title: 'Planejamento da Contratação',
            subtitle:
                'Atuo no planejamento de contratações da PRODESP...',
            prompt: 'Atuo no planejamento de contratações da PRODESP. Preciso de apoio técnico-jurídico para elaborar o tópico xxxxxxxxxxx do documento xxxxxxxxxxx, referente à contratação de xxxxxxxxxx. Considere que xxxxxxxxxx, bem como os elementos exigidos pelo RILC para esse documento. Indique os pontos que dependem de aprovação da Gerência Jurídica ou de manifestação da Consultoria Jurídica.',
        },
        {
            id: 'impugnacao',
            title: 'Impugnação ao Edital',
            subtitle: 'Sou responsável pela condução de licitação da PRODESP...',
            prompt: 'Sou responsável pela condução de licitação da PRODESP. Considerando o Edital e a Impugnação em [ANEXO], minute uma resposta à impugnação, enfrentando cada argumento à luz das cláusulas do Edital. Considere que xxxxxxxxxxxx. Além do mérito, verifique a tempestividade da impugnação em relação ao prazo fixado no próprio edital.',
        },
        {
            id: 'gestao_contratos',
            title: 'Gestão de Contratos',
            subtitle:
                'Sou fiscal/gestor de um contrato da PRODESP e preciso decidir sobre um pleito...',
            prompt: 'Sou fiscal/gestor de um contrato da PRODESP e preciso decidir sobre um pleito da contratada. O objeto é xxxxxxxxxx. A contratada solicita xxxxxxxxxx, sob o argumento de que xxxxxxxxxx. O contrato está em [ANEXO]. Considere que xxxxxxxxxx. Analise o caso à luz das cláusulas contratuais, do RILC e dos preceitos de direito privado.',
        },
    ]

    const CHAT_SUGGESTIONS_SCPAR = [
        {
            id: 'planejamento',
            title: 'Planejamento da Contratação',
            subtitle:
                'Atuo na unidade responsável pelo planejamento da contratação da SCPar...',
            prompt: 'Atuo na unidade responsável pelo planejamento da contratação da SCPar Porto de São Francisco do Sul S.A. e preciso de apoio técnico-jurídico para um caso concreto. Por favor, elabore uma minuta de texto para o tópico xxxxxxxxxxxxxx do documento xxxxxxxxxxxxxxx (ex.: termo de referência, anteprojeto, projeto básico, instrumento convocatório, minuta de contrato ou matriz de riscos). Considere que xxxxxxxxxxxxxx, bem como os elementos exigidos pelo RILC para esse documento.',
        },
        {
            id: 'impugnacao',
            title: 'Impugnação ao Edital',
            subtitle:
                'Sou membro da comissão de licitação em um processo licitatório da SCPar...',
            prompt: 'Sou membro da comissão de licitação em um processo licitatório da SCPar Porto de São Francisco do Sul S.A. e recebi uma impugnação ao instrumento convocatório. Considerando o Edital e a Impugnação em [ANEXO], minute uma resposta à impugnação, enfrentando cada argumento à luz das cláusulas do Edital. Considere que xxxxxxxxxxxx.',
        },
        {
            id: 'gestao_contratos',
            title: 'Gestão de Contratos',
            subtitle:
                'Sou fiscal/gestor de um contrato da SCPar e preciso decidir sobre um pleito...',
            prompt: 'Sou fiscal/gestor de um contrato da SCPar e preciso decidir sobre um pleito apresentado pela contratada. O objeto é xxxxxxxxxx. A contratada solicita xxxxxxxxxx, sob o argumento de que xxxxxxxxxx. O contrato está em [ANEXO]. Minute uma manifestação sobre o pleito, a ser submetida à autoridade competente, com introdução, desenvolvimento e conclusão e com uma análise jurídica sobre o pedido. Analise o caso à luz das cláusulas contratuais, do RILC, da Lei 13.303/2016 e dos preceitos de direito privado.',
        },
    ]

    const CHAT_SUGGESTIONS_SEBRAE = [
        {
            id: 'planejamento',
            title: 'Planejamento de Contratação',
            subtitle:
                'Sou da equipe responsável pelo planejamento de contratações do Sebrae Nacional...',
            prompt: 'Sou da equipe responsável pelo planejamento de contratações do Sebrae Nacional e preciso de apoio técnico-jurídico para um caso concreto, à luz do Regulamento de Licitações e Contratos do Sistema Sebrae (Resolução CDN nº 641/2026) e da natureza jurídica privada dos serviços sociais autônomos (art. 2º). Por favor, elabore uma minuta de texto para o tópico xxxxxxxxxxxxxx do documento xxxxxxxxxxxxxxx. Considere que xxxxxxxxxxxxxx.',
        },
        {
            id: 'impugnacao',
            title: 'Questionamento ao Edital',
            subtitle:
                'Sou membro da comissão de licitação em uma licitação do Sebrae Nacional...',
            prompt: 'Sou membro da comissão de licitação em uma licitação do Sebrae Nacional, regida pelo Regulamento de Licitações e Contratos do Sistema Sebrae (Resolução CDN nº 641/2026), e recebi um questionamento/impugnação ao edital, apresentado com base no art. 27, § 2º. Minute uma resposta ao questionamento, com introdução, desenvolvimento e conclusão. Apresente o argumento do questionamento e uma análise jurídica sobre ele. Ao final, conclua pela procedência ou pela improcedência do questionamento. O conteúdo do questionamento é este: xxxxxxxxxxxx. Considere, para a sua análise, que xxxxxxxxxxxxxxx.',
        },
        {
            id: 'gestao_contratos',
            title: 'Gestão de Contratos',
            subtitle:
                'Sou fiscal/gestor de um contrato celebrado pelo Sebrae Nacional...',
            prompt: 'Sou fiscal/gestor de um contrato celebrado pelo Sebrae Nacional e preciso decidir sobre um pleito apresentado pela contratada. Minute uma resposta ao pleito, com introdução, desenvolvimento e conclusão, com uma análise jurídica fundamentada no Regulamento de Licitações e Contratos do Sistema Sebrae (Resolução CDN nº 641/2026), nas cláusulas do edital e do contrato e, se houver lacuna, nas normas de direito civil e nos princípios gerais do direito privado (art. 77). Quando for pertinente, considere as regras sobre alterações e termos aditivos (arts. 40 e 41), prorrogação de vigência (art. 36), reajuste, repactuação e reequilíbrio econômico-financeiro (art. 44), apostilamento (art. 45) e penalidades (arts. 42 e 43). Ao final, conclua pela procedência ou pela improcedência. A contratada solicita que xxxxxxx, sob o argumento de que xxxxxxxx. Considere, para a sua análise, que xxxxxxxxxxx.',
        },
    ]

    const CHAT_SUGGESTIONS_PROCON = [
        {
            id: 'procon',
            title: 'Resposta do PROCON',
            subtitle: 'Sou analista do PROCON/SP...',
            prompt: 'Sou analista do PROCON/SP e preciso fornecer instrução a um consumidor que passou pela seguinte situação: xxxxxxxxxx. Redija uma orientação clara e fundamentada a ser encaminhada oficialmente pelo PROCON.',
        },
        {
            id: 'orientacao_consumidor',
            title: 'Orientação ao consumidor',
            subtitle: 'Um consumidor passou pela seguinte situação...',
            prompt: 'Um consumidor passou pela seguinte situação problemática: xxxxxxxxxx. Elabore uma orientação a ser enviada a ele pela empresa fornecedora, de maneira clara e fundamentada.',
        },
        {
            id: 'analise_caso',
            title: 'Análise de caso',
            subtitle: 'Sou fornecedor de xxxxxxxxxx, e um consumidor...',
            prompt: 'Sou fornecedor de xxxxxxxxxx, e um consumidor relatou ter passado pela seguinte situação: xxxxxxxxxx. Considerando a jurisprudência e normas aplicáveis, como devo proceder e quais medidas devem ser tomadas?',
        },
    ]

    const handleMotorChange = (selectedAssistant: any) => {
        setAssistant(selectedAssistant)
        setIsDropdownOpen(false)
    }

    // Pergunta que veio na URL (?pergunta=): entra no input como sugestão —
    // PRÉ-PREENCHIDA, nunca enviada; o crédito só é consumido se a pessoa
    // apertar enter. Espera a conversa estar selecionada porque o Input limpa
    // o texto a cada troca de conversa, e é aplicada uma única vez: daí em
    // diante o texto é da pessoa.
    const perguntaAplicada = useRef(false)
    useEffect(() => {
        if (!perguntaInicial || perguntaAplicada.current || !selected?.guid) {
            return
        }
        perguntaAplicada.current = true
        setSuggestion(perguntaInicial)
    }, [perguntaInicial, selected?.guid])

    useEffect(() => {
        gerarNovoId()
        console.log('messagesArray updated', messagesArray)
    }, [messagesArray])

    useLayoutEffect(() => {
        if (messagesArray.length === 0) {
            return
        }

        const frame = window.requestAnimationFrame(() => {
            listRef.current?.scrollToIndex({
                index: messagesArray.length - 1,
                align: 'end',
                behavior: 'auto',
            })
            const nextLabel = getDateLabel(
                messagesArray[messagesArray.length - 1].created_at
            )
            setVisibleDateLabel((prev) =>
                prev === nextLabel ? prev : nextLabel
            )
        })

        return () => window.cancelAnimationFrame(frame)
    }, [messagesArray.length, lastMessageText, listHeight])

    useLayoutEffect(() => {
        if (!scrollContentRef.current) {
            return
        }

        const element = scrollContentRef.current
        const observer = new ResizeObserver(() => {
            setListHeight(element.getBoundingClientRect().height)
        })

        observer.observe(element)
        setListHeight(element.getBoundingClientRect().height)

        return () => observer.disconnect()
    }, [])

    useEffect(() => {
        if (messagesArray.length === 0) {
            setVisibleDateLabel('')
        }
    }, [messagesArray.length])

    const handleRangeChanged = useCallback(
        (range: {startIndex: number; endIndex: number}) => {
            const item = messagesArray[range.startIndex]
            if (!item) {
                return
            }

            const nextLabel = getDateLabel(item.created_at)
            setVisibleDateLabel((prev) =>
                prev === nextLabel ? prev : nextLabel
            )
        },
        [messagesArray]
    )

    const renderMessageRow = useCallback(
        (index: number) => {
            const item = messagesArray[index]
            const messageKey =
                item.message_id ||
                `${item.thread_id}-${new Date(item.created_at).getTime()}-${item.content.substring(0, 20)}-${index}`

            return (
                <BodyMessage key={messageKey} isUser={!!item.author_id}>
                    <Message
                        message={item}
                        arrayLength={messagesArray.length}
                        index={index}
                        loadingMessageBot={loadingMessageBot}
                    />
                </BodyMessage>
            )
        },
        [loadingMessageBot, messagesArray]
    )

    useEffect(() => {
        console.log('.')
    }, [archivedThread])

    useEffect(() => {
        if (loadingMessageBot) {
            setIsLoading(true)
        } else {
            setIsLoading(false)
        }
    }, [loadingMessageBot])

    useEffect(() => {
        if (
            (limits?.usages.messages.current === 3 &&
                limits?.usages.messages.max === 3) ||
            (limits?.usages.messages.current === 0 &&
                limits?.usages.messages.max === 0)
        ) {
            console.log('entrou')
            setFinishedTest(true)
        } else setFinishedTest(false)
    }, [limits])

    const gerarNovoId = () => {
        const novoId = uuidv4()
        setUuid(novoId)
    }

    const _desarquivarModal = () => {
        return (
            <Modal
                onClose={handleClose}
                open={unarchieveModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                disablePortal
                disableEnforceFocus
            >
                <ModalContent>
                    <HeadModal>
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                        >
                            Chats arquivados
                        </Typography>
                        <StyledIconButton onClick={handleClose}>
                            <CloseIcon />
                        </StyledIconButton>
                    </HeadModal>
                    <Divider orientation="horizontal" flexItem />
                    <BodyModal>
                        <TableContainer component={Box}>
                            <Table
                                sx={{minWidth: 200}}
                                aria-label="simple table"
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Nome</TableCell>
                                        <TableCell align="right"></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {archivedThread?.map((item) => (
                                        <TableRow
                                            key={item.guid}
                                            sx={{
                                                '&:last-child td, &:last-child th':
                                                    {border: 0},
                                            }}
                                        >
                                            <TableCell
                                                component="th"
                                                scope="row"
                                            >
                                                <ChatOutlinedIcon
                                                    sx={{marginRight: '10px'}}
                                                />
                                                {item.name}
                                            </TableCell>
                                            <TableCell align="right">
                                                <IconButton
                                                    onClick={() =>
                                                        unarchiveThread(
                                                            item.guid
                                                        )
                                                    }
                                                >
                                                    <UnarchiveOutlinedIcon />
                                                </IconButton>
                                                {
                                                    // <IconButton>
                                                    //     <DeleteOutlinedIcon
                                                    //         onClick={() =>
                                                    //             deleteThread(
                                                    //                 item.guid
                                                    //             )
                                                    //         }
                                                    //     />
                                                    // </IconButton>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </BodyModal>
                    <PaginationControls>
                        <IconButton
                            disabled={archivedThreadPage === 1}
                            onClick={() =>
                                goToArchivedThreadsPage(archivedThreadPage - 1)
                            }
                        >
                            <KeyboardArrowLeftIcon />
                        </IconButton>
                        <IconButton
                            disabled={(archivedThread?.length || 0) < 15}
                            onClick={() =>
                                goToArchivedThreadsPage(archivedThreadPage + 1)
                            }
                        >
                            <KeyboardArrowRightIcon />
                        </IconButton>
                    </PaginationControls>
                </ModalContent>
            </Modal>
        )
    }

    const finishedTestModal = () => {
        return (
            <Modal onClose={handleClose} open={finishedTest}>
                <ModalContent>
                    <HeadModal>
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                        >
                            Período de teste finalizado
                        </Typography>
                    </HeadModal>
                    <Divider orientation="horizontal" flexItem />
                    <BodyModal
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                        }}
                    >
                        <Typography
                            id="modal-modal-description"
                            sx={{mt: 2, mb: 3}}
                        >
                            Seus créditos esgotaram, para continuar usando entre
                            em contato com um consultor:
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                bgcolor: '#25D366',
                                color: 'white',
                                p: 2,
                                borderRadius: 2,
                                cursor: 'pointer',
                                '&:hover': {bgcolor: '#20BA5C'},
                                mt: 2,
                                maxWidth: '80%',
                            }}
                            onClick={() =>
                                window.open(
                                    'https://api.whatsapp.com/send/?phone=554198002461&text=Quero+falar+com+um+Consultor!&type=phone_number&app_absent=0'
                                )
                            }
                        >
                            <WhatsAppIcon sx={{fontSize: 30, mr: 1}} />
                            <Typography fontWeight="bold">
                                Falar com um consultor
                            </Typography>
                        </Box>
                    </BodyModal>
                </ModalContent>
            </Modal>
        )
    }

    return (
        <>
            <Section>
                <TopBar>
                    <TopBarContent className="motor-dropdown">
                        <MotorButton
                            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                            isOpen={isDropdownOpen}
                        >
                            <div className="button-content">
                                <PulsingCircle />
                                <ButtonTitle>
                                    {assistant?.name ||
                                        'Selecione um assistente'}
                                </ButtonTitle>
                            </div>
                            <KeyboardArrowDownIcon className="arrow-icon" />
                        </MotorButton>

                        <DropdownMenu isOpen={isDropdownOpen}>
                            {assistants?.map((ast) => (
                                <MenuItem
                                    key={ast.guid}
                                    isSelected={ast.guid === assistant?.guid}
                                    onClick={() => handleMotorChange(ast)}
                                >
                                    {ast.name}
                                </MenuItem>
                            ))}
                        </DropdownMenu>
                    </TopBarContent>
                </TopBar>
                <ScrollContent ref={scrollContentRef}>
                    {selected?.name ? (
                        messagesArray[0]?.content ==
                            'Olá, como posso ajudar?' &&
                        messagesArray.length === 1 &&
                        window.innerWidth > 640 ? (
                            <Body noMessage={false}>
                                <NewMessageContainer>
                                    {!window.location.hostname.includes(
                                        'procon'
                                    ) && (
                                        <div
                                            style={{
                                                padding: '7px',
                                                backgroundColor:
                                                    COLORS.secundaria,
                                                borderRadius: '20px',
                                                justifyContent: 'center',
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <img
                                                src={GuruICon}
                                                alt="Guru Icon"
                                                style={{
                                                    width: '71px',
                                                    height: '71px',
                                                }}
                                            />
                                        </div>
                                    )}
                                    <TitleNewMessage>
                                        Olá, {userInfo.first_name} <br /> Como
                                        posso te ajudar hoje?
                                    </TitleNewMessage>
                                    <SubtitleNewMessage>
                                        IA Generativa & Banco de Dados sob
                                        curadoria de Gustavo Schiefler
                                        {!window.location.hostname.includes(
                                            'procon'
                                        ) && ' e Joel de Menezes Niebuhr'}
                                    </SubtitleNewMessage>
                                    <SugestionsContainer>
                                        {(window.location.hostname.includes(
                                            'procon'
                                        )
                                            ? CHAT_SUGGESTIONS_PROCON
                                            : window.location.hostname.includes(
                                                    'finep'
                                                )
                                              ? CHAT_SUGGESTIONS_FINEP
                                              : window.location.hostname.includes(
                                                      'prodesp'
                                                  )
                                                ? CHAT_SUGGESTIONS_PRODESP
                                                : window.location.hostname.includes(
                                                        'sebrae'
                                                    )
                                                  ? CHAT_SUGGESTIONS_SEBRAE
                                                  : window.location.hostname.includes(
                                                          'scpar'
                                                      )
                                                    ? CHAT_SUGGESTIONS_SCPAR
                                                    : CHAT_SUGGESTIONS
                                        ).map((suggestion) => (
                                            <SugestionContent
                                                key={suggestion.id}
                                                onClick={() =>
                                                    setSuggestion(
                                                        suggestion.prompt
                                                    )
                                                }
                                                title={suggestion.prompt}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems:
                                                            'flex-start',
                                                    }}
                                                >
                                                    <Image
                                                        src={ChatIcon}
                                                        alt="Chat Icon"
                                                    />
                                                    <div style={{flex: 1}}>
                                                        <SugestionTitle>
                                                            {suggestion.title}
                                                        </SugestionTitle>
                                                        <SugestionSubtitle>
                                                            {
                                                                suggestion.subtitle
                                                            }
                                                        </SugestionSubtitle>
                                                    </div>
                                                </div>
                                            </SugestionContent>
                                        ))}
                                    </SugestionsContainer>
                                </NewMessageContainer>
                            </Body>
                        ) : (
                            <Body2 noMessage={false}>
                                {visibleDateLabel && (
                                    <DateSeparatorWrapper isSticky>
                                        <DateBadge>{visibleDateLabel}</DateBadge>
                                    </DateSeparatorWrapper>
                                )}
                                <Virtuoso
                                    ref={listRef}
                                    data={messagesArray}
                                    followOutput="auto"
                                    style={{
                                        height: listHeight || 400,
                                        width: '100%',
                                    }}
                                    rangeChanged={handleRangeChanged}
                                    itemContent={(index) =>
                                        renderMessageRow(index)
                                    }
                                />
                            </Body2>
                        )
                    ) : (
                        <Body2 noMessage>
                            <NoMessageText>
                                Selecione uma conversa.
                            </NoMessageText>
                        </Body2>
                    )}
                </ScrollContent>
                <BottomBar>
                    <BottomBarContent>
                        {openModelAlertLimit && (
                            <Alert
                                style={{alignSelf: 'flex-end'}}
                                variant="filled"
                                severity="error"
                                onClose={() => {
                                    setOpenModelAlertLimit(false)
                                }}
                            >
                                Seus Créditos para gerar consultas acabaram
                            </Alert>
                        )}
                        <Input suggestion={suggestion} />
                        <Footer>
                            <span>powered by Schief.ai</span>
                            <span>· A IA pode errar. Confira as informações antes de decidir.</span>
                        </Footer>
                    </BottomBarContent>
                </BottomBar>
            </Section>
            {_desarquivarModal()}
            {finishedTestModal()}
        </>
    )
}
